<template>
  <div ref="tceVideo" class="tce-video">
    <video
      ref="video"
      src=""
      :muted="muted"
      :loop="loop"
      type="video/mp4"
      preload="metadata"
      playsinline
    />
    <button v-if="controls" ref="videoControl" class="tce-video__control" @click="togglePlaying">
      <img :src="playButtonSrc" alt="" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'tce-video',
};
</script>

<script setup>
import { computed, onMounted, ref, watch } from 'vue';

const MOBILE_SCREEN_END = 767;

const props = defineProps({
  sources: { type: Object, default: null },
  autoplay: { type: Boolean, default: false },
  muted: { type: Boolean, default: true },
  loop: { type: Boolean, default: true },
  controls: { type: Boolean, default: true },
  lazyloading: { type: Boolean, default: true },
});

const tceVideo = ref(null);
const video = ref(null);
const videoControl = ref(null);
const playing = ref(props.autoplay);

const isMobile = computed(() => {
  return window.innerWidth < MOBILE_SCREEN_END;
});

const videoSrc = computed(() => {
  return isMobile.value ? props.sources.mobile : props.sources.desktop;
});

const playButtonSrc = computed(() => {
  return playing.value ? '/ui/icons/pause.svg' : '/ui/icons/play.svg';
});

watch(playing, (isPlaying) => {
  isPlaying ? video.value.play() : video.value.pause();
});

function load() {
  video.value.src = videoSrc.value;
}

function togglePlaying() {
  playing.value = !playing.value;
}

function toggleVideoByObserve() {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (props.lazyloading) load();
          playing.value = true;
        } else {
          playing.value = false;
        }
      });
    },
    {
      threshold: 0.1,
    },
  );

  const target = tceVideo.value.querySelector('video');

  observer.observe(target);
}

onMounted(() => {
  toggleVideoByObserve();

  if (!props.lazyloading) {
    load();
  }
});
</script>

<style lang="scss">
@import '../../styles/style.scss';
@import './style.scss';
</style>
